import request from '@/util/request'
import Event from '@/util/proto/event'

const initCluster = () => {
  return new Promise((resolve) => {
    AMapUI.load(['ui/geo/DistrictCluster'], (DistrictCluster) => {
      resolve(DistrictCluster)
    });
  })
}

class ClusterLayer extends Event{
  constructor(map){
    super()
    this.map = map
  }

  async init(){
    let DistrictCluster = await initCluster()
    this.poiCluster = new DistrictCluster({
      map: this.map,
      autoSetFitView: false,
     
      renderOptions: {
        animEnable: false,
        featureStyleByLevel: {
          country: { fillStyle: 'rgba(0,0,0,0)' },
          province: { fillStyle: 'rgba(0,0,0,0)' },
          city: { fillStyle: 'rgba(0,0,0,0)' },
          district: { fillStyle: 'rgba(0,0,0,0)' }
        },
        featureStyle: {
          lineWidth: 0
        },
        featureEventSupport: false, //区划面是否开启事件支持
        featureClickToShowSub: false, //点击区划面是否触发进入子级区划
        hoverOptions: null,
        getClusterMarker: function(feature, dataItems, recycledMarker) {
          if (dataItems.length > 0) {
            return DistrictCluster.ClusterMarkerStrategy.DEFAULT.call(this, feature, dataItems, recycledMarker)
          }
        }

      },
      getPosition: (item) => {
        return [item.lng, item.lat]
      },
    });

    this.poiCluster.on('clusterMarkerClick', this.handleClusterClick.bind(this))

  }

  handleClusterClick(e,record){
    this.trigger('click', record)
  }

  setData(data){
    this.poiCluster.setData(data)
  }

  show(){
    this.poiCluster.show()
  }

  hide(){
    this.poiCluster.hide()
  }
}

ClusterLayer.create = async function(map){
  let instance = new ClusterLayer(map)
  await instance.init()
  return instance
}

export default ClusterLayer